import Debug from "./debug";


export default class EventManager {

    public static readonly instance: EventManager = new EventManager();
    private handles = {};

    dispatch(eventName: string, ...data) {
        var returns = [] //返回值
        for (var findEvenName in this.handles) {
            if (findEvenName == eventName) {
                for (var i = 0; i < this.handles[findEvenName].length; i++) {
                    var returnValue = null
                    let length = 0
                    let eventData = this.handles[findEvenName][i]
                    let callback = eventData.callback
                    let target = eventData.target
                    let once = eventData.once
                    if (data) {
                        length = data.length
                    }
                    if (length == 0) {
                        returnValue = callback.call(target)
                    } else if (length == 1) {
                        returnValue = callback.call(target, data[0])
                    }
                    else if (length == 2) {
                        returnValue = callback.call(target, data[0], data[1])
                    }
                    else if (length == 3) {
                        returnValue = callback.call(target, data[0], data[1], data[2])
                    }
                    else if (length == 4) {
                        returnValue = callback.call(target, data[0], data[1], data[2], data[3])
                    }
                    else if (length == 5) {
                        returnValue = callback.call(target, data[0], data[1], data[2], data[3], data[4])
                    }
                    else if (length == 6) {
                        returnValue = callback.call(target, data[0], data[1], data[2], data[3], data[4], data[5])
                    }
                    else if (length == 7) {
                        returnValue = callback.call(target, data[0], data[1], data[2], data[3], data[4], data[5], data[6])
                    }
                    else {
                        returnValue = callback.call(target, data)
                    }
                    returns.push(returnValue)
                    if (once) {
                        this.off(eventName, callback, target)
                    }
                }
            }
        }
        return returns
    }

    has(eventName: string, callback: Function, target): boolean {
        if (this.handles[eventName] == null) {
            return false
        }

        let length = this.handles[eventName].length
        for (let i = 0; i < length; i++) {
            if (this.handles[eventName][i].callback == callback && (this.handles[eventName][i].target == target)) {
                return true
            }
        }
        return false
    }

    //如果是同一个回调函数多次调用会过滤后面的函数
    on(eventName: string, callback: Function, target, directCall : boolean, onceCall = false) {
        if (!directCall) {
            cc.error("禁止直接调用EventManager.instance.on事件绑定方法，请使用基类的事件绑定方法")
            return
        }
        if (this.handles[eventName] == null) {
            this.handles[eventName] = [];
        }
        let data = {
            "callback": callback,
            "target": target,
            "once" : onceCall
        }
        if (!this.has(eventName, callback, target)) {
            this.handles[eventName].push(data)
        }
        else {
            cc.warn("重复注册事件:", eventName)
            let length = this.handles[eventName].length
            for (let i = 0; i < length; i++) {
                if (this.handles[eventName][i].callback == callback && this.handles[eventName][i].target == target) {
                    this.handles[eventName][i] = data
                }
            }
        }
    }

    off(eventName: string, callback: Function, target) {
        if (this.handles[eventName] == null) {
            return;
        }
        for (var i = 0; i < this.handles[eventName].length; i++) {
            if (this.handles[eventName][i].callback === callback && this.handles[eventName][i].target === target) {
                this.handles[eventName].splice(i, 1)
                break
            }
        }
    }

    clearAll() {
        this.handles = {};
    }
}
